import React from 'react';
import { connect } from 'react-redux';

import AidesList from '../../List/Aides/AidesList';

const mapStateToProps = ({
  dialog: {
    contentProps: {
      filter,
      sort = { id: -1 },
      count = 25,
    },
  },
}) => ({
  filter,
  sort,
  count,
});

const AidesListDialog = ({ filter, sort, count }) => (
  <AidesList
    filterName="default"
    filter={filter}
    sort={sort}
    count={count}
  />
);

export default connect(mapStateToProps)(AidesListDialog);
